import type { ISite } from "@similarweb/ui-components";

import { getAutoCompleteSuggestions } from "app/helpers/autocompleteWrapper";
import { RankTrackerQueryType } from "app/pages/digital-marketing/keywords-campaigns/shared/constants";
import { createRankTrackerQueryKey } from "app/pages/digital-marketing/keywords-campaigns/shared/utils";

import { useRankTrackerQuery } from "../useRankTrackerQuery";

export const useCompetitorSuggestionsQuery = (filterValue: string) => {
    return useRankTrackerQuery<ISite[]>({
        queryKey: createRankTrackerQueryKey(RankTrackerQueryType.CompetitorSuggestions, [filterValue]),
        enabled: !!filterValue,
        queryFn: () => getAutoCompleteSuggestions({ term: filterValue }),
    });
};
